import { useMutation, useQueryClient } from '@tanstack/vue-query'
import type { SuccessResponse } from '~/types/response'
import type { RegisterVerifyEmailDTO } from '~/schemas/auth/register'
import { queries } from '~/keys'

const useQuestionnaire = () => {
  const { fetch } = useAPIFetch()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: RegisterVerifyEmailDTO) =>
      fetch<SuccessResponse<any>>({
        method: 'POST',
        url: 'users/me/questionnaire',
        data: payload,
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries(queries.users.me)

      navigateTo({
        name: 'dashboard',
      })
    },
  })
}

export default useQuestionnaire
